import { GetVehicleModelsResponse } from "@/app/api/vehicle-models/route";
import { getVehicleModelsRequestSchema } from "@/lib/schemas/vehicle-models";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const VEHICLE_MODELS_ENDPOINT = "/api/vehicle-models";

export const invalidateVehicleModelsQuery = createInvalidateQuery(
  VEHICLE_MODELS_ENDPOINT,
);

export const useVehicleModelsQuery = createQueryHook<GetVehicleModelsResponse>(
  VEHICLE_MODELS_ENDPOINT,
  getVehicleModelsRequestSchema,
);
